import { loadClientWidgets } from "../utils/loadClientWidgets";
import { widgetsLmp } from "../widgets";
import "@sky-it-livedata/livedata-sports-design-system/lib/styles/stylesheet.min.css";
import { activeTabScrollIntoView, clickFromHash } from "../utils/tabs-utils";
import { heroSlimSticky } from "../utils/sticky-hero";
import resumeAthletePages from "../utils/resume-athlete-pages";
import { ageCalc } from "@sky-it-livedata/common-web-app-utils/browser";
import { hydrateTabsMenu } from "../utils/hydrate-tabs-menu";
import manageImagePlaceholders from "../utils/placeholder-images";

export const initClient = () => loadClientWidgets(widgetsLmp);

initClient();
manageImagePlaceholders();

document.addEventListener('DOMContentLoaded', () => {
    ageCalc();
    resumeAthletePages();
    heroSlimSticky();
    hydrateTabsMenu();
    activeTabScrollIntoView();
    clickFromHash();
});


